/* Ko Samui — product card "Add to cart" toggles the size quick-add, Stone Island style. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.si-card-add');
    var open = document.querySelectorAll('product-card.si-sizes-open');
    if (!btn) {
      if (!e.target.closest('.product-card-sizes--container')) open.forEach(function (c) { c.classList.remove('si-sizes-open'); });
      return;
    }
    e.preventDefault();
    var card = btn.closest('product-card');
    var willOpen = !card.classList.contains('si-sizes-open');
    open.forEach(function (c) { c.classList.remove('si-sizes-open'); });
    card.classList.toggle('si-sizes-open', willOpen);
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  });
})();

/* Ko Samui — Stone Island header: hide while scrolling down, show again on scroll up. */
(function () {
  'use strict';
  var section = null, header = null, lastY = window.scrollY, ticking = false, hidden = false;
  function els() {
    header = document.querySelector('.header');
    section = header && header.closest('.shopify-section');
    return !!section;
  }
  function set(h) {
    if (h === hidden) return;
    hidden = h;
    section.classList.toggle('si-header-hidden', h);
  }
  function update() {
    ticking = false;
    if (!section && !els()) return;
    var y = Math.max(0, window.scrollY), dy = y - lastY, hh = header.offsetHeight;
    section.style.setProperty('--si-header-h', hh + 'px');
    var busy = header.matches(':hover') || header.contains(document.activeElement) ||
      document.body.classList.contains('open-cc') || document.querySelector('.side-panel.active, .side-panel[open]');
    section.classList.toggle('si-header-scrolled', y > hh + 40);
    if (y <= hh + 40 || busy) set(false);
    else if (dy > 6) set(true);
    else if (dy < -6) set(false);
    lastY = y;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
})();

/* Ko Samui — Stone Island style fullscreen product zoom.
   Click a product photo: fullscreen gallery on light grey, vertical thumbnails on the right,
   "– 100% +" zoom controls, drag to pan, pinch / ctrl+wheel / double-click to zoom, Esc to close. */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  var STEPS = [1, 1.5, 2, 2.5, 3];
  var modal, stage, img, thumbs, pct, items = [], index = 0, scale = 1, tx = 0, ty = 0, lastFocus = null;

  function hiRes(url) {
    try {
      var u = new URL(url, location.href);
      u.searchParams.set('width', '2400');
      return u.toString();
    } catch (e) { return url; }
  }

  function collect() {
    var slides = document.querySelectorAll('.product-images__slide--image');
    var out = [];
    slides.forEach(function (s) {
      if (s.offsetParent === null && getComputedStyle(s).display === 'none') return;
      var a = s.querySelector('.product-single__media-zoom');
      var im = s.querySelector('img');
      var src = (a && a.getAttribute('href')) || (im && (im.currentSrc || im.src));
      if (!src) return;
      out.push({ slide: s, src: hiRes(src), thumb: hiRes(src).replace('width=2400', 'width=200'), alt: (im && im.alt) || '' });
    });
    return out;
  }

  function build() {
    modal = document.createElement('div');
    modal.className = 'si-zoom';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Product images');
    modal.innerHTML =
      '<button type="button" class="si-zoom__close" aria-label="Close">' +
        '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.4" fill="none"/></svg></button>' +
      '<div class="si-zoom__stage"><img class="si-zoom__img" alt="" draggable="false"></div>' +
      '<ul class="si-zoom__thumbs" role="tablist"></ul>' +
      '<p class="si-zoom__hint">Pinch to zoom</p>' +
      '<div class="si-zoom__ctrl">' +
        '<button type="button" data-z="-1" aria-label="Zoom out">&minus;</button>' +
        '<span class="si-zoom__pct">100%</span>' +
        '<button type="button" data-z="1" aria-label="Zoom in">+</button>' +
      '</div>';
    document.body.appendChild(modal);
    stage = modal.querySelector('.si-zoom__stage');
    img = modal.querySelector('.si-zoom__img');
    thumbs = modal.querySelector('.si-zoom__thumbs');
    pct = modal.querySelector('.si-zoom__pct');

    modal.querySelector('.si-zoom__close').addEventListener('click', close);
    modal.querySelectorAll('[data-z]').forEach(function (b) {
      b.addEventListener('click', function () { step(parseInt(b.getAttribute('data-z'), 10)); });
    });
    thumbs.addEventListener('click', function (e) {
      var li = e.target.closest('li');
      if (li) show(parseInt(li.getAttribute('data-i'), 10));
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') show(index + 1);
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === '+' || e.key === '=') step(1);
      else if (e.key === '-') step(-1);
      else if (e.key === 'Tab') trap(e);
    });

    // Wheel: ctrl/pinch-trackpad zooms, plain wheel changes image when not zoomed.
    var wheelLock = 0;
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      if (e.ctrlKey) { setScale(scale * (e.deltaY < 0 ? 1.1 : 0.9), e.clientX, e.clientY); return; }
      if (scale > 1) { pan(-e.deltaX, -e.deltaY); return; }
      var now = Date.now();
      if (now - wheelLock < 450 || Math.abs(e.deltaY) < 8) return;
      wheelLock = now;
      show(index + (e.deltaY > 0 ? 1 : -1));
    }, { passive: false });

    // Double click toggles 100% / 200%.
    stage.addEventListener('dblclick', function (e) { setScale(scale > 1 ? 1 : 2, e.clientX, e.clientY); });

    // Pointer: drag to pan, two fingers to pinch, swipe to change image at 100%.
    var pts = {}, start = null, pinch = null;
    stage.addEventListener('pointerdown', function (e) {
      stage.setPointerCapture(e.pointerId);
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), s: scale };
      } else {
        start = { x: e.clientX, y: e.clientY, tx: tx, ty: ty };
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 2 && pinch) {
        var a = pts[ids[0]], b = pts[ids[1]];
        setScale(pinch.s * Math.hypot(a.x - b.x, a.y - b.y) / pinch.d, (a.x + b.x) / 2, (a.y + b.y) / 2);
      } else if (start && scale > 1) {
        tx = start.tx + (e.clientX - start.x);
        ty = start.ty + (e.clientY - start.y);
        apply();
      }
    });
    function end(e) {
      var p = pts[e.pointerId];
      delete pts[e.pointerId];
      if (Object.keys(pts).length < 2) pinch = null;
      if (start && p && scale === 1 && !Object.keys(pts).length) {
        var dx = p.x - start.x, dy = p.y - start.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
        else if (Math.abs(dy) > 60) show(index + (dy < 0 ? 1 : -1));
      }
      if (!Object.keys(pts).length) start = null;
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
  }

  function trap(e) {
    var f = modal.querySelectorAll('button, li[tabindex]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function clampPan() {
    var w = stage.clientWidth, h = stage.clientHeight;
    var iw = img.offsetWidth * scale, ih = img.offsetHeight * scale;
    var mx = Math.max(0, (iw - w) / 2), my = Math.max(0, (ih - h) / 2);
    tx = Math.max(-mx, Math.min(mx, tx));
    ty = Math.max(-my, Math.min(my, ty));
  }
  function apply() {
    clampPan();
    img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    pct.textContent = Math.round(scale * 100) + '%';
    modal.classList.toggle('is-zoomed', scale > 1);
  }
  function setScale(s, cx, cy) {
    var ns = Math.max(1, Math.min(3, s));
    if (cx !== undefined) {
      var r = stage.getBoundingClientRect();
      var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
      tx = ox - (ox - tx) * (ns / scale);
      ty = oy - (oy - ty) * (ns / scale);
    }
    scale = ns;
    if (scale === 1) { tx = 0; ty = 0; }
    apply();
  }
  function step(dir) {
    var i = 0;
    while (i < STEPS.length - 1 && STEPS[i] < scale - 0.01) i++;
    if (dir > 0) i = STEPS[i] > scale + 0.01 ? i : Math.min(STEPS.length - 1, i + 1);
    else i = STEPS[i] < scale - 0.01 ? i : Math.max(0, i - 1);
    setScale(STEPS[i]);
  }
  function pan(dx, dy) { tx += dx; ty += dy; apply(); }

  // Use the photo's own background colour for the gallery, so the image edge disappears.
  function matchBg() {
    try {
      var c = document.createElement('canvas'); c.width = c.height = 4;
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, 40, 40, 0, 0, 4, 4);
      var d = x.getImageData(0, 0, 1, 1).data;
      modal.style.backgroundColor = 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')';
    } catch (e) { modal.style.backgroundColor = ''; }
  }

  function show(i) {
    if (!items.length) return;
    index = (i + items.length) % items.length;
    scale = 1; tx = 0; ty = 0;
    img.classList.add('is-loading');
    img.onload = function () { img.classList.remove('is-loading'); matchBg(); apply(); };
    img.src = items[index].src;
    img.alt = items[index].alt;
    thumbs.querySelectorAll('li').forEach(function (li, k) {
      li.classList.toggle('is-active', k === index);
      li.setAttribute('aria-selected', k === index ? 'true' : 'false');
      if (k === index) li.scrollIntoView({ block: 'nearest' });
    });
    apply();
  }

  function open(startSlide) {
    items = collect();
    if (!items.length) return;
    if (!modal) build();
    thumbs.innerHTML = items.map(function (it, k) {
      return '<li role="tab" tabindex="0" data-i="' + k + '" aria-label="Image ' + (k + 1) + '"><img src="' + it.thumb + '" alt="" loading="lazy"></li>';
    }).join('');
    var start = 0;
    items.forEach(function (it, k) { if (it.slide === startSlide) start = k; });
    lastFocus = document.activeElement;
    document.documentElement.classList.add('si-zoom-open');
    modal.classList.add('is-open');
    show(start);
    modal.querySelector('.si-zoom__close').focus();
  }
  function close() {
    modal.classList.remove('is-open', 'is-zoomed');
    document.documentElement.classList.remove('si-zoom-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Capture phase so the theme's own lightbox never opens.
  document.addEventListener('click', function (e) {
    if (e.target.closest('.si-wl, .si-wl-ph, .si-pdp-wl')) return; // wishlist "+" on the photo: never open the zoom
    var slide = e.target.closest('.product-images__slide--image');
    if (!slide || !slide.closest('.product-image-container, .product-images')) return;
    e.preventDefault();
    e.stopPropagation();
    open(slide);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && document.activeElement && document.activeElement.closest('.si-zoom__thumbs li')) {
      show(parseInt(document.activeElement.getAttribute('data-i'), 10));
    }
  });
})();

/* Ko Samui — Stone Island style colour selector on product cards.
   "+ N COLORS" toggle opens a row of solid colour rectangles (current one underlined).
   Colours come from the Swatch King sibling products; each rectangle's colour is the
   dominant garment colour of that product's photo. Hover previews, click opens the product. */
(function () {
  'use strict';
  var CACHE_KEY = 'si-swatch-colors-v1';
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); } catch (e) {}
  function save() { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {} }

  function sized(url, w) {
    try { var u = new URL(url, location.href); u.searchParams.set('width', String(w)); return u.toString(); } catch (e) { return url; }
  }

  // Dominant non-background colour of a product photo (prints/labels are a minority of the fabric).
  function dominant(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var W = 60, H = Math.round(60 * im.naturalHeight / im.naturalWidth);
          var c = document.createElement('canvas'); c.width = W; c.height = H;
          var x = c.getContext('2d'); x.drawImage(im, 0, 0, W, H);
          var d = x.getImageData(0, 0, W, H).data;
          var br = d[0], bg = d[1], bb = d[2];
          var buckets = {}, best = null, bestN = 0;
          for (var y = Math.floor(H * 0.15); y < H * 0.9; y++) {
            for (var xx = Math.floor(W * 0.15); xx < W * 0.85; xx++) {
              var i = (y * W + xx) * 4, r = d[i], g = d[i + 1], b = d[i + 2];
              if (Math.abs(r - br) + Math.abs(g - bg) + Math.abs(b - bb) < 24) continue; // background
              var k = (r >> 4) + ',' + (g >> 4) + ',' + (b >> 4);
              var e = buckets[k] || (buckets[k] = { n: 0, r: 0, g: 0, b: 0 });
              e.n++; e.r += r; e.g += g; e.b += b;
              if (e.n > bestN) { bestN = e.n; best = e; }
            }
          }
          var col = best ? 'rgb(' + Math.round(best.r / best.n) + ',' + Math.round(best.g / best.n) + ',' + Math.round(best.b / best.n) + ')' : 'rgb(' + br + ',' + bg + ',' + bb + ')';
          cache[url] = col; save(); resolve(col);
        } catch (err) { resolve(null); }
      };
      im.onerror = function () { resolve(null); };
      im.src = sized(url, 120);
    });
  }

  window.__siDominant = dominant;

  function enhance(card) {
    if (card.__siColors) return;
    var sk = card.querySelector('variant-swatch-king');
    if (!sk) return;
    var lis = sk.querySelectorAll('.swatch-view-item');
    var data = sk.querySelectorAll('.vsk-product-images-data > [data-product-handle]');
    if (lis.length < 2 || data.length !== lis.length) return;
    card.__siColors = true;

    var items = [];
    lis.forEach(function (li, k) {
      var dv = data[k];
      items.push({
        name: li.getAttribute('orig-value') || li.getAttribute('aria-label') || '',
        url: dv.getAttribute('data-product-handle'),
        img: dv.getAttribute('data-featured-image'),
        active: !!li.querySelector('.swatch-selected') || li.getAttribute('aria-checked') === 'true'
      });
    });
    if (!items.some(function (it) { return it.active; })) {
      var here = (card.querySelector('.product-card-title') || {}).getAttribute ? card.querySelector('.product-card-title').getAttribute('href') : '';
      items.forEach(function (it) { if (here && here.indexOf(it.url.split('/').pop()) > -1) it.active = true; });
    }

    var label = (sk.querySelector('.swatch-option-name') || {}).textContent || 'Colors';
    var wrap = document.createElement('div');
    wrap.className = 'si-colors';
    wrap.innerHTML =
      '<button type="button" class="si-colors__toggle" aria-expanded="false">' +
        '<span class="si-colors__sign" aria-hidden="true">+</span>' +
        '<span>' + items.length + ' ' + label.trim() + '</span></button>' +
      '<ul class="si-colors__list" hidden></ul>';
    var list = wrap.querySelector('.si-colors__list');
    items.forEach(function (it) {
      var li = document.createElement('li');
      li.innerHTML = '<a href="' + it.url + '" class="si-colors__chip' + (it.active ? ' is-active' : '') + '" aria-label="' + it.name.replace(/"/g, '&quot;') + '" title="' + it.name.replace(/"/g, '&quot;') + '"></a>';
      var chip = li.firstChild;
      chip.setAttribute('data-img', it.img || '');
      dominant(it.img).then(function (col) { if (col) chip.style.backgroundColor = col; });
      chip.addEventListener('mouseenter', function () { preview(card, it.img); });
      list.appendChild(li);
    });
    list.addEventListener('mouseleave', function () { preview(card, null); });

    var btn = wrap.querySelector('.si-colors__toggle');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = list.hidden;
      list.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      wrap.querySelector('.si-colors__sign').textContent = open ? '—' : '+';
    });

    var anchor = card.querySelector('.product-card-info .price');
    if (anchor) anchor.parentNode.insertBefore(wrap, anchor); else card.querySelector('.product-card-info').appendChild(wrap);
    card.classList.add('si-has-colors');
  }

  // Hover preview: swap the card's main photo to the hovered colour.
  window.__siColorPreview = function (card, url) { preview(card, url); };
  function preview(card, url) {
    var img = card.querySelector('.product-primary-image');
    if (!img) return;
    if (!img.__siOrig) img.__siOrig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
    if (url) {
      img.setAttribute('srcset', sized(url, 400) + ' 400w, ' + sized(url, 800) + ' 800w');
      img.setAttribute('src', sized(url, 800));
      card.classList.add('si-previewing');
    } else {
      if (img.__siOrig.srcset) img.setAttribute('srcset', img.__siOrig.srcset); else img.removeAttribute('srcset');
      img.setAttribute('src', img.__siOrig.src);
      card.classList.remove('si-previewing');
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('product-card').forEach(enhance);
  }
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
})();

/* Ko Samui — Stone Island style colour selector on the product page:
   "COLORS: NAVY" label + row of solid 52x20 rectangles, current one underlined. */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  function bgUrl(el) {
    var m = el && (el.getAttribute('style') || '').match(/url\(["']?([^"')]+)/);
    if (!m) return null;
    try { var u = new URL(m[1], location.href); ['width', 'height', 'crop'].forEach(function (k) { u.searchParams.delete(k); }); return u.toString(); } catch (e) { return m[1]; }
  }

  // Only the Swatch King "product group" (colours = sibling products); size options stay untouched.
  function enhance(sk) {
    if (sk.__siDone) return;
    var lis = sk.querySelectorAll('.swatch-view-item');
    if (!sk.matches('[type-group="true"]')) return;
    if (lis.length < 1 || !window.__siDominant) return;
    sk.__siDone = true;

    var items = [];
    lis.forEach(function (li) {
      var sw = li.querySelector('.swatch-image');
      items.push({
        name: li.getAttribute('orig-value') || li.getAttribute('aria-label') || '',
        url: sw && sw.getAttribute('swatch-url'),
        img: bgUrl(li.querySelector('[style*="background-image"]')),
        active: !!(sw && (sw.classList.contains('swatch-selected') || sw.getAttribute('current-product') === 'true'))
      });
    });
    var current = items.filter(function (it) { return it.active; })[0] || items[0];
    var label = ((sk.querySelector('.swatch-option-name') || {}).textContent || 'Colors').trim();

    var box = document.createElement('div');
    box.className = 'si-pcolors';
    box.innerHTML = '<p class="si-pcolors__label"><strong>' + label + ':</strong> <span class="si-pcolors__value"></span></p><ul class="si-pcolors__list"></ul>';
    var value = box.querySelector('.si-pcolors__value');
    value.textContent = current.name;
    var list = box.querySelector('.si-pcolors__list');
    items.forEach(function (it) {
      var li = document.createElement('li');
      var a = document.createElement(it.url ? 'a' : 'span');
      a.className = 'si-pcolors__chip' + (it.active ? ' is-active' : '');
      if (it.url) a.href = it.url;
      a.setAttribute('aria-label', it.name);
      a.title = it.name;
      if (it.active) a.setAttribute('aria-current', 'true');
      if (it.img) window.__siDominant(it.img).then(function (c) { if (c) a.style.backgroundColor = c; });
      a.addEventListener('mouseenter', function () { value.textContent = it.name; });
      a.addEventListener('focus', function () { value.textContent = it.name; });
      li.appendChild(a);
      list.appendChild(li);
    });
    list.addEventListener('mouseleave', function () { value.textContent = current.name; });

    sk.parentNode.insertBefore(box, sk);
    sk.classList.add('si-hidden-swatches');
  }

  function scan() {
    document.querySelectorAll('.product-information variant-swatch-king [type-group="true"], .product-form variant-swatch-king [type-group="true"]').forEach(enhance);
  }
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();

/* Ko Samui — apply the site font (Geist Mono) inside third-party widgets that use an open Shadow DOM
   (e.g. Tidio chat), which the global stylesheet cannot reach. */
(function () {
  'use strict';
  var CSS = '*, *::before, *::after { font-family: "Geist Mono", ui-monospace, Menlo, Arial, sans-serif !important; letter-spacing: 0 !important; }';
  var HOSTS = ['#tidio-chat'];
  function patch() {
    HOSTS.forEach(function (sel) {
      var host = document.querySelector(sel);
      var sr = host && host.shadowRoot;
      if (!sr || sr.querySelector('style[data-si-font]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-si-font', '');
      st.textContent = CSS;
      sr.appendChild(st);
    });
  }
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; patch(); }, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });
  patch();
})();

/* Ko Samui — header right as text links (Stone Island style): SEARCH  ACCOUNT  WISHLIST  CART (0).
   Labels are added next to the existing icons; CSS shows text on desktop and keeps icons on mobile. */
(function () {
  'use strict';
  var LABELS = [
    ['.thb-secondary-area .thb-quick-search', 'Search'],
    ['.thb-secondary-area .thb-secondary-myaccount', 'Account'],
    ['.thb-secondary-area #swym-reformation-desktop', 'Wishlist'],
    ['.thb-secondary-area .thb-secondary-cart .thb-secondary-item-icon', 'Cart']
  ];
  function label() {
    LABELS.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (el) {
        if (el.querySelector(':scope > .si-hlabel')) return;
        var s = document.createElement('span');
        s.className = 'si-hlabel';
        s.textContent = pair[1];
        var count = el.querySelector(':scope > .thb-item-count, :scope > .swym-header-launcher-badge');
        el.insertBefore(s, count || null);
      });
    });
    // Swym puts its badge inside the icon wrapper: move it next to the label so it reads "WISHLIST (2)".
    document.querySelectorAll('#swym-reformation-desktop').forEach(function (a) {
      var badge = a.querySelector('.swym-header-launcher-icon .swym-header-launcher-badge');
      if (badge) a.appendChild(badge);
    });
  }
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; label(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', label); else label();
})();

/* Wishlist before cookie consent: Wishlist Plus only loads after the visitor accepts cookies, so its "+" buttons are missing.
   Show identical placeholder "+" buttons; a click remembers the product, shows a short message and reopens the cookie banner.
   Once cookies are accepted and Wishlist Plus is ready, the remembered product is saved to the wishlist. */
(function () {
  if (window.__siWlGate) return;
  window.__siWlGate = true;
  var KEY = 'si-wl-pending';

  function swymReady() { return !!(window._swat && window._swat.api); }
  function consentOk() {
    try { return window.Shopify.customerPrivacy.preferencesProcessingAllowed() === true; } catch (e) { return false; }
  }
  function gated() { return !swymReady() && !consentOk(); }

  function placeholders() {
    if (!gated()) { document.querySelectorAll('.si-wl-ph').forEach(function (b) { b.remove(); }); return; }
    document.querySelectorAll('product-card[data-si-empi]').forEach(function (card) {
      var fig = card.querySelector('.product-card--featured-image');
      if (!fig || fig.querySelector('.si-wl-ph, .swym-wishlist-collections-v2-container')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'si-wl-ph';
      b.setAttribute('aria-label', 'Add to wishlist');
      b.setAttribute('data-epi', card.getAttribute('data-si-epi'));
      b.setAttribute('data-empi', card.getAttribute('data-si-empi'));
      b.setAttribute('data-du', card.getAttribute('data-si-du'));
      fig.appendChild(b);
    });
    // Home rails: their "+" stay hidden until Wishlist Plus is ready — show them so they can be clicked.
    document.querySelectorAll('.si-wl[hidden]').forEach(function (b) { b.hidden = false; });
  }

  function toast(text) {
    var t = document.querySelector('.si-toast');
    if (!t) { t = document.createElement('div'); t.className = 'si-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = text;
    t.classList.add('is-visible');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 5000);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.si-wl-ph, .si-wl');
    if (!b || swymReady()) return;
    e.preventDefault();
    e.stopPropagation();
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        epi: Number(b.getAttribute('data-epi')), empi: Number(b.getAttribute('data-empi')), du: b.getAttribute('data-du')
      }));
    } catch (err) {}
    // No decision yet: the cookie banner is available, reopen it. Already declined: the banner app no longer loads,
    // so ask only for the "preferences" permission the wishlist needs.
    if (typeof window.__avadaReopenBanner === 'function') {
      toast('Accept cookies to use the wishlist. Your item will be saved right after.');
      try { window.__avadaReopenBanner(); } catch (err) {}
    } else {
      ask();
    }
  }, true);

  function ask() {
    var d = document.querySelector('.si-consent');
    if (!d) {
      d = document.createElement('div');
      d.className = 'si-consent';
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-modal', 'true');
      d.setAttribute('aria-label', 'Wishlist');
      d.innerHTML = '<div class="si-consent__box">' +
        '<p class="si-consent__title">Wishlist</p>' +
        '<p class="si-consent__text">To save items to your wishlist we need your permission to store your preferences on this device. Marketing and analytics cookies stay off.</p>' +
        '<div class="si-consent__actions"><button type="button" class="si-consent__allow">Allow</button><button type="button" class="si-consent__cancel">Not now</button></div>' +
        '</div>';
      document.body.appendChild(d);
      d.addEventListener('click', function (e) {
        if (e.target.closest('.si-consent__cancel') || e.target === d) {
          d.classList.remove('is-open');
          try { sessionStorage.removeItem(KEY); } catch (err) {}
        }
        if (e.target.closest('.si-consent__allow')) {
          d.classList.remove('is-open');
          allow();
        }
      });
    }
    d.classList.add('is-open');
    var btn = d.querySelector('.si-consent__allow'); if (btn) btn.focus();
  }

  function allow() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    if (!p || !p.setTrackingConsent) { location.reload(); return; }
    p.setTrackingConsent({ preferences: true }, function () {
      toast('Saving to your wishlist…');
      // Wishlist Plus normally starts by itself; if it does not, a reload picks the remembered item up.
      setTimeout(function () { if (!swymReady()) location.reload(); }, 4000);
    });
  }

  // After consent: save the remembered product as soon as Wishlist Plus is ready.
  (window.SwymCallbacks = window.SwymCallbacks || []).push(function (sw) {
    document.querySelectorAll('.si-wl-ph').forEach(function (b) { b.remove(); });
    var raw = null;
    try { raw = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (err) {}
    if (!raw) return;
    var prod; try { prod = JSON.parse(raw); } catch (err) { return; }
    var add = function (lid) {
      sw.api.addToList(lid, prod, function () { toast('Added to your wishlist'); }, function () {});
    };
    sw.api.fetchLists({
      callbackFn: function (lists) {
        if (lists && lists[0]) add(lists[0].lid);
        else sw.api.createList({ lname: 'My Wishlist' }, function (l) { add(l.lid); }, function () {});
      },
      errorFn: function () {}
    });
  });

  var timer = 0;
  function schedule() { clearTimeout(timer); timer = setTimeout(placeholders, 300); }
  // Start whether or not the page "load" event has already fired (Safari / the cookie app can run this script late),
  // and check again a few times in case the cookie decision comes in after.
  var started = false;
  function start() {
    if (started) return;
    started = true;
    placeholders();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    [3000, 6000].forEach(function (ms) { setTimeout(placeholders, ms); });
  }
  if (document.readyState === 'complete') setTimeout(start, 1500);
  else window.addEventListener('load', function () { setTimeout(start, 1500); });
  setTimeout(start, 5000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
})();

/* Collection cards (desktop and mobile): "+ Availability" toggle (like "+ 2 Colors").
   - Tapping it lists the sizes; sold-out sizes are crossed out, available sizes add straight to the cart on tap.
   - Tapping a colour switches the card to that colour (photo, links, price) without leaving the page,
     and the availability is updated for that colour. */
(function () {
  if (window.__siAvail) return;
  window.__siAvail = true;

  // Sizes of the product currently shown on the card: [{ name, variantId|null, available }]
  function themeSizes(card) {
    return Array.prototype.map.call(card.querySelectorAll('.product-card-sizes--size'), function (s) {
      return { name: s.textContent.trim(), available: !s.classList.contains('is-disabled'), el: s };
    });
  }
  function render(card) {
    var w = card.__siAvailWrap;
    if (!w) return;
    var list = w.querySelector('.si-avail__list');
    var sizes = card.__siAltSizes || themeSizes(card);
    list.innerHTML = '';
    if (!sizes.length) { list.textContent = 'Sold out'; return; }
    sizes.forEach(function (s) {
      var el;
      if (s.available) {
        el = document.createElement('button');
        el.type = 'button';
        el.setAttribute('aria-label', 'Add size ' + s.name + ' to cart');
        el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); add(card, s, el); });
      } else {
        el = document.createElement('s');
        el.setAttribute('aria-label', s.name + ' sold out');
      }
      el.className = 'si-avail__size' + (s.available ? '' : ' is-out');
      el.textContent = s.name;
      list.appendChild(el);
    });
  }
  function setOpen(card, open) {
    var w = card.__siAvailWrap;
    var list = w.querySelector('.si-avail__list');
    if (open) render(card);
    list.hidden = !open;
    w.querySelector('.si-avail__toggle').setAttribute('aria-expanded', open ? 'true' : 'false');
    w.querySelector('.si-colors__sign').textContent = open ? '—' : '+';
  }

  // Add to cart: the card's own product uses the theme's quick add; another colour posts the variant directly.
  function add(card, s, el) {
    if (s.el && !card.__siAltSizes) { s.el.click(); flash(el); return; }
    if (!s.variantId) return;
    el.classList.add('is-loading');
    var fd = new FormData();
    fd.append('id', s.variantId);
    fd.append('quantity', 1);
    var sections = typeof card.getSectionsToRender === 'function' ? card.getSectionsToRender().map(function (x) { return x.section; }) : [];
    if (sections.length) { fd.append('sections', sections); fd.append('sections_url', location.pathname); }
    fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) return;
      if (typeof card.renderContents === 'function' && res.sections) card.renderContents(res);
      if (typeof window.dispatchCustomEvent === 'function') window.dispatchCustomEvent('cart:item-added', { product: res.items ? res.items[0] : res });
      flash(el);
    }).catch(function () {}).finally(function () { el.classList.remove('is-loading'); });
  }
  function flash(el) { el.classList.add('is-added'); setTimeout(function () { el.classList.remove('is-added'); }, 1200); }

  // Colour tap (mobile): switch the card instead of opening the product.
  function money(card, cents) {
    var a = card.querySelector('.price .amount') || card.querySelector('.price ins span') || card.querySelector('.price');
    if (!a) return;
    var txt = a.textContent.trim();
    var m = txt.match(/[\d.,\s]+\d/);
    if (!m) return;
    var dec = /,\d{2}$/.test(m[0]) ? ',' : '.';
    var n = (cents / 100).toFixed(2);
    a.textContent = txt.replace(m[0], dec === ',' ? n.replace('.', ',') : n);
  }
  function switchColour(card, chip) {
    var href = chip.getAttribute('href');
    card.__siSwitched = true;
    card.querySelectorAll('.si-colors__chip').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
    if (window.__siColorPreview && chip.getAttribute('data-img')) {
      window.__siColorPreview(card, chip.getAttribute('data-img'));
      // Make the chosen colour the card's photo (the hover preview would otherwise restore the original on mouse-out).
      var img = card.querySelector('.product-primary-image');
      if (img) img.__siOrig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
      card.classList.add('si-switched');
    }
    card.querySelectorAll('.product-card-title, .product-card--featured-image-link').forEach(function (a) { a.setAttribute('href', href); });
    var t = card.querySelector('.product-card-title'); if (t && chip.title) t.setAttribute('title', chip.title);
    var original = card.getAttribute('data-si-orig-href');
    if (!original) card.setAttribute('data-si-orig-href', original = (card.querySelector('.product-card-title') || {}).pathname || '');
    fetch(href.split('?')[0] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var opts = (p.options || []).map(function (o) { return (o.name || o).toString(); });
      var idx = opts.findIndex(function (n) { return /size|taglia|größe|taille/i.test(n); });
      if (idx < 0) idx = 0;
      var seen = {};
      var sizes = [];
      (p.variants || []).forEach(function (v) {
        var name = v.options[idx];
        if (seen[name]) { if (v.available) seen[name].available = true, seen[name].variantId = v.id; return; }
        seen[name] = { name: name, available: !!v.available, variantId: v.id };
        sizes.push(seen[name]);
      });
      // Back on the card's own product: use the theme's sizes again.
      card.__siAltSizes = (href.indexOf(card.getAttribute('data-si-handle') || '\u0000') > -1) ? null : sizes;
      if (p.price) money(card, p.price);
      var tt = card.querySelector('.product-card-title'); if (tt && p.title) tt.textContent = p.title;
      setOpen(card, true);
    }).catch(function () {});
  }

  function build(card) {
    if (card.__siAvailWrap) return;
    var sizes = card.querySelectorAll('.product-card-sizes--size');
    if (!sizes.length) return;
    var title = card.querySelector('.product-card-title');
    if (title) card.setAttribute('data-si-handle', '/products/' + (title.getAttribute('href') || '').split('/products/').pop().split('?')[0]);
    var wrap = document.createElement('div');
    wrap.className = 'si-avail';
    wrap.innerHTML =
      '<button type="button" class="si-colors__toggle si-avail__toggle" aria-expanded="false">' +
        '<span class="si-colors__sign" aria-hidden="true">+</span><span>Availability</span></button>' +
      '<p class="si-avail__list" hidden></p>';
    card.__siAvailWrap = wrap;
    wrap.querySelector('.si-avail__toggle').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(card, wrap.querySelector('.si-avail__list').hidden);
    });
    var anchor = card.querySelector('.product-card-info .price');
    if (anchor) anchor.parentNode.insertBefore(wrap, anchor); else (card.querySelector('.product-card-info') || card).appendChild(wrap);
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.si-colors__chip');
    if (!chip) return;
    var card = chip.closest('product-card');
    if (!card || !card.__siAvailWrap) return;
    e.preventDefault();
    e.stopPropagation();
    switchColour(card, chip);
  }, true);

  // The colour shown on the card is the card's own product: mark that chip as active (unless the shopper switched).
  function markActive(card) {
    var h = card.getAttribute('data-si-handle');
    if (!h || card.__siSwitched) return;
    card.querySelectorAll('.si-colors__chip').forEach(function (c) {
      c.classList.toggle('is-active', (c.getAttribute('href') || '').split('?')[0] === h);
    });
  }
  function scan() { document.querySelectorAll('product-card').forEach(function (c) { build(c); markActive(c); }); }
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 200); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();

/* Collection filters (Stone Island style): sticky bar under the header, tabs, live product count, sort list. */
(function () {
  var root = document.querySelector('[data-si-filters]');
  if (!root || root.__si) return;
  root.__si = true;
  var form = root.querySelector('[data-si-panel="filter"]');
  var sortPanel = root.querySelector('[data-si-panel="sort"]');
  var veil = root.querySelector('.si-filters__veil');
  var label = root.querySelector('[data-si-count-label]');
  var apply = root.querySelector('.si-filters__apply');

  // Sticky right under the header. When the header slides away, the bar slides up by exactly the same
  // amount with the same transform animation (GPU, no layout change), so the two never come apart,
  // even during fast momentum scrolling on phones.
  var header = document.querySelector('.header-section');
  var lastH = -1;
  function place() {
    var hh = header ? Math.round(header.offsetHeight) : 0;
    var up = !!(header && header.classList.contains('si-header-hidden'));
    if (hh !== lastH) { lastH = hh; root.style.setProperty('--si-filters-stick', hh + 'px'); }
    root.classList.toggle('si-filters--up', up);
    root.style.setProperty('--si-filters-top', (up ? 0 : hh) + 'px'); // visual top, used by the open panel
  }
  if (header) new MutationObserver(place).observe(header, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', place);
  if (header && window.ResizeObserver) new ResizeObserver(place).observe(header);
  place();

  function open(which) {
    var f = which === 'filter', s = which === 'sort';
    // Bring the bar to its sticky spot first, so the whole panel (with the Apply button) fits on screen.
    if (f || s) {
      // Scrolling down hides the header, so the bar ends up at the very top.
      var gap = root.getBoundingClientRect().top;
      if (gap > 1) window.scrollBy(0, gap);
    }
    form.hidden = !f; sortPanel.hidden = !s; veil.hidden = !(f || s);
    root.querySelectorAll('[data-si-open]').forEach(function (b) {
      var on = b.getAttribute('data-si-open') === which;
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      b.querySelector('.si-filters__sign').textContent = on ? '—' : '+';
    });
    document.documentElement.classList.toggle('si-filters-open', f || s);
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-si-open]');
    if (b) { var w = b.getAttribute('data-si-open'); open(b.getAttribute('aria-expanded') === 'true' ? null : w); return; }
    if (e.target.closest('[data-si-close]')) { open(null); return; }
    var acc = e.target.closest('[data-si-acc]');
    if (acc) {
      var g = acc.closest('.si-filters__group');
      var on = !g.classList.contains('is-open');
      g.classList.toggle('is-open', on);
      acc.setAttribute('aria-expanded', on ? 'true' : 'false');
      acc.querySelector('.si-filters__sign').textContent = on ? '—' : '+';
      return;
    }
    var tab = e.target.closest('[data-si-tab]');
    if (tab) {
      var n = tab.getAttribute('data-si-tab');
      root.querySelectorAll('[data-si-tab]').forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      root.querySelectorAll('[data-si-group]').forEach(function (g) { g.hidden = g.getAttribute('data-si-group') !== n; });
    }
    if (e.target.closest('[data-si-clear]')) {
      e.preventDefault();
      form.querySelectorAll('input[type=checkbox]').forEach(function (i) { i.checked = false; });
      form.querySelectorAll('.si-filters__price input').forEach(function (i) { i.value = ''; });
      count();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(null); });

  // Live count: ask Shopify for this section with the chosen filters and read the product count.
  function params() {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') p.append(k, v); });
    return p;
  }
  function text(n) { return (n === 1 ? root.getAttribute('data-one') : root.getAttribute('data-other')).replace('__N__', n); }
  var timer = 0, seq = 0;
  function count() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var my = ++seq, p = params();
      p.set('section_id', root.getAttribute('data-section'));
      apply.classList.add('is-loading');
      fetch(root.getAttribute('data-url') + '?' + p.toString()).then(function (r) { return r.text(); }).then(function (html) {
        if (my !== seq) return;
        var m = html.match(/data-si-count="(\d+)"/);
        if (m) label.textContent = text(parseInt(m[1], 10));
      }).catch(function () {}).finally(function () { if (my === seq) apply.classList.remove('is-loading'); });
    }, 250);
  }
  form.addEventListener('change', count);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var p = params();
    location.href = root.getAttribute('data-url') + (p.toString() ? '?' + p.toString() : '');
  });
})();

/* Mobile home: white logo while the header is over the hero (see "si-hdr-light" in si-theme.css). */
(function () {
  if (!document.body || !document.body.classList.contains('template-index')) return;
  var mq = window.matchMedia('(max-width: 767px)');
  var hero = document.querySelector('.si-hero');
  var header = document.querySelector('.header-section');
  if (!hero || !header) return;
  function update() {
    var on = mq.matches && hero.getBoundingClientRect().bottom > header.getBoundingClientRect().bottom + 20;
    document.documentElement.classList.toggle('si-hdr-light', on);
  }
  var raf = 0;
  window.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

/* Header "WISHLIST" text link: Wishlist Plus only reacts to clicks on its (hidden on desktop) heart icon,
   so a click anywhere on the launcher is passed to the icon — which opens the wishlist page. */
(function () {
  if (window.__siWlLauncher) return;
  window.__siWlLauncher = true;
  document.addEventListener('click', function (e) {
    var launcher = e.target.closest('#swym-reformation-desktop, .swym-header-launcher');
    if (!launcher || e.target.closest('.swym-header-launcher-icon')) return;
    var icon = launcher.querySelector('.swym-header-launcher-icon');
    e.preventDefault();
    e.stopPropagation();
    if (icon) icon.click();
    else location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'pages/swym-wishlist';
  }, true);
})();

/* Cart drawer (Upcart), Stone Island style: header reads "CART" + "n PRODUCTS" on the right. */
(function () {
  if (window.__siCartHead) return;
  window.__siCartHead = true;
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var L = {
    it: ['Carrello', 'prodotto', 'prodotti'], de: ['Warenkorb', 'Artikel', 'Artikel'],
    fr: ['Panier', 'produit', 'produits'], en: ['Cart', 'product', 'products']
  }[lang] || ['Cart', 'product', 'products'];
  function update() {
    var pop = document.getElementById('CartPopup');
    if (!pop) return;
    var head = pop.querySelector('.upcart-header, .upcart-public-header');
    if (!head) return;
    var title = head.querySelector('.upcart-header-text, h3');
    if (title && title.textContent.trim() !== L[0]) title.textContent = L[0];
    var n = 0;
    pop.querySelectorAll('.upcart-product-item .upcart-product-quantity-input, .upcart-public-cart-item input').forEach(function (i) { n += parseInt(i.value, 10) || 0; });
    // Sharper product photos: Upcart loads 176px thumbnails, the drawer shows them larger.
    pop.querySelectorAll('.upcart-product-image-wrapper img, .upcart-public-component-product-tile__image').forEach(function (img) {
      var s = img.getAttribute('src') || '';
      if (/[?&]height=\d+/.test(s) && !/[?&]width=600/.test(s)) img.setAttribute('src', s.replace(/([?&])height=\d+/, '$1width=600'));
    });
    // "Continue as a registered user" box: the "LOG IN OR SIGN UP" line becomes a link, and the whole box opens the login page.
    pop.querySelectorAll('.upcart-public-announcement').forEach(function (box) {
      if (box.querySelector('.si-ann-link')) return;
      var login = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'account/login';
      var strongs = box.querySelectorAll('strong');
      var last = null;
      strongs.forEach(function (s) { if (/log ?in|sign ?up|accedi|iscriv/i.test(s.textContent)) last = s; });
      if (last) {
        var txt = last.textContent.replace(/^\s+/, '');
        var a = document.createElement('a');
        a.href = login; a.className = 'si-ann-link'; a.textContent = txt;
        last.innerHTML = '<br><br>';
        last.appendChild(a);
      }
      if (!box.__siClick) { box.__siClick = true; box.addEventListener('click', function (e) { if (!e.target.closest('a')) location.href = login; }); }
    });
    var c = head.querySelector('.si-cart-count');
    if (!c) { c = document.createElement('span'); c.className = 'si-cart-count'; head.insertBefore(c, head.querySelector('.upcart-header-close-button, .upcart-public-header__close-button')); }
    var txt = n + ' ' + (n === 1 ? L[1] : L[2]);
    if (c.textContent !== txt) c.textContent = txt;
  }
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(update, 60); })
    .observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('#CartPopup')) update(); }, true);
})();

/* Header language switcher (desktop): "EN" opens/closes the small list; click outside or Esc closes it. */
(function () {
  if (window.__siLang) return;
  window.__siLang = true;
  function closeAll(except) {
    document.querySelectorAll('.si-lang--header.is-open').forEach(function (w) {
      if (w === except) return;
      w.classList.remove('is-open');
      var b = w.querySelector('.si-lang__toggle'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.si-lang__toggle');
    if (t) {
      e.preventDefault();
      var w = t.closest('.si-lang--header');
      var open = !w.classList.contains('is-open');
      closeAll(w);
      w.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!e.target.closest('.si-lang__panel')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();

/* Swym wishlist texts: our wishlist button is a "+", not a heart — swap ♡ / ♥ / ❤ in Swym's empty-state copy. */
(function () {
  var SEL = '[class*="swym-storefront-layout-empty"]';
  var RE = /[♡♥❤]️?/g;
  function fix(root) {
    (root.querySelectorAll ? root : document).querySelectorAll(SEL).forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) { if (RE.test(n.nodeValue)) { RE.lastIndex = 0; n.nodeValue = n.nodeValue.replace(RE, '+'); } }
    });
  }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { fix(document); }, 50); })
    .observe(document.documentElement, { childList: true, subtree: true });
  fix(document);
})();

/* C:Hub account page: profile custom fields come in Italian (Compleanno / Sesso / Uomo / Donna) — show them in the page language. */
(function () {
  if (location.pathname.indexOf('/a/customerhub') === -1) return;
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var MAP = {
    en: { 'Compleanno': 'Birthday', 'Sesso': 'Gender', 'Uomo': 'Man', 'Donna': 'Woman' },
    de: { 'Compleanno': 'Geburtstag', 'Sesso': 'Geschlecht', 'Uomo': 'Mann', 'Donna': 'Frau' },
    fr: { 'Compleanno': 'Anniversaire', 'Sesso': 'Genre', 'Uomo': 'Homme', 'Donna': 'Femme' }
  }[lang];
  if (!MAP) return;
  function fix() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), n, k;
    while ((n = w.nextNode())) {
      k = n.nodeValue.trim();
      if (MAP[k] && !n.parentNode.closest('script,style,option,textarea')) n.nodeValue = n.nodeValue.replace(k, MAP[k]);
    }
  }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(fix, 60); })
    .observe(document.body, { childList: true, subtree: true, characterData: true });
  fix();
})();

/* Swym wishlist login banner: shorter, clearer English copy. */
(function () {
  var COPY = {
    '.swym-storefront-layout-login-heading': 'Keep your wishlist',
    '.swym-storefront-layout-login-description': 'Log in to save your pieces for good and find them on any device.'
  };
  function fix() {
    Object.keys(COPY).forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { if (el.textContent.trim() !== COPY[sel]) el.textContent = COPY[sel]; });
    });
  }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(fix, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  fix();
})();

/* Mobile menu "WISHLIST (n)": count copied from the Swym badge; opens the Swym wishlist the same way the header link does. */
(function () {
  function sync() {
    var badge = document.querySelector('.swym-header-launcher-badge');
    var n = badge ? parseInt(badge.textContent, 10) : 0;
    document.querySelectorAll('[data-si-menu-wl-count]').forEach(function (el) { el.textContent = n > 0 ? '(' + n + ')' : ''; });
  }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 150); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  sync();
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-si-menu-wl]');
    if (!a) return;
    var icon = document.querySelector('.swym-header-launcher-icon');
    if (icon) { e.preventDefault(); icon.click(); }
  });
})();

/* Content pages: "< BACK" at the top (or "< HOME" when arriving from outside the site) and, on the story pages,
   a closing bar "< BACK TO HOME · NEXT 40x ... >" that walks through the home "Focus" stories in order. */
(function () {
  if (!document.body.classList.contains('template-page')) return;
  var m = location.pathname.match(/\/pages\/([^/?#]+)/);
  if (!m) return;
  var handle = m[1];
  var prefix = location.pathname.slice(0, m.index); // keeps /it, /de… for the links
  // Story pages in the same order as the home "Focus" block. A page added later (e.g. the fit guide) just joins the loop.
  var STORIES = [
    { handle: 'quality', code: '401', title: 'Made in Italy' },
    { handle: 'loyalty-programme-1', code: '402', title: 'KST Club' },
    { handle: 'fit-guide', code: '403', title: 'Fit guide', pending: true },
    { handle: 'about-us', code: '404', title: 'About us' }
  ].filter(function (s) { return !s.pending; });
  var idx = STORIES.map(function (s) { return s.handle; }).indexOf(handle);
  var story = idx > -1 ? STORIES[idx] : null;
  var main = document.getElementById('main-content');
  if (!main || main.querySelector('.si-pnav')) return;

  var fromSite = false;
  try { fromSite = !!document.referrer && new URL(document.referrer).origin === location.origin && new URL(document.referrer).pathname !== location.pathname; } catch (e) {}

  // Top
  var top = document.createElement('div');
  top.className = 'si-pnav';
  var back = document.createElement('a');
  back.className = 'si-pnav__back';
  back.href = prefix + '/';
  back.innerHTML = '<span aria-hidden="true">&lt;</span>' + (fromSite ? 'Back' : 'Home');
  if (fromSite) back.addEventListener('click', function (e) { e.preventDefault(); history.back(); });
  top.appendChild(back);
  if (story) {
    var code = document.createElement('span');
    code.className = 'si-pnav__code';
    code.textContent = story.code + ' · ' + story.title;
    top.appendChild(code);
  }
  var first = main.querySelector(':scope > .shopify-section');
  var overHero = first && first.querySelector('.si-ph, .image-with-text-overlay, .background-video');
  if (overHero) { top.classList.add('si-pnav--over'); first.style.position = 'relative'; first.appendChild(top); }
  else main.insertBefore(top, main.firstChild);

  // Bottom (story pages only)
  if (!story) return;
  var next = STORIES[(idx + 1) % STORIES.length];
  var bar = document.createElement('nav');
  bar.className = 'si-pnav-end';
  bar.setAttribute('aria-label', 'Continue');
  bar.innerHTML =
    '<a class="si-pnav-end__home" href="' + prefix + '/"><span aria-hidden="true">&lt;</span>Back to home</a>' +
    '<a class="si-pnav-end__next" href="' + prefix + '/pages/' + next.handle + '"><span class="si-pnav-end__label">Next</span>' +
    '<span class="si-pnav-end__code">' + next.code + '</span>' + next.title + '<span aria-hidden="true">&gt;</span></a>';
  main.appendChild(bar);
})();

/* Tidio chat, Stone-style: the Tidio launcher is hidden; the chat opens from a small "CHAT" button (shown once you
   scroll) and from "Chat with us" links (footer, product page, mobile menu). Links fall back to the contact page. */
(function () {
  var ready = false;
  function api() { return window.tidioChatApi; }
  function onReady() {
    if (ready || !api()) return;
    ready = true;
    try { api().hide(); } catch (e) {}
    try { api().on('close', function () { try { api().hide(); } catch (e) {} }); } catch (e) {}
    document.documentElement.classList.add('si-chat-ready');
  }
  if (window.tidioChatApi) window.tidioChatApi.on('ready', onReady);
  else document.addEventListener('tidioChat-ready', onReady);
  var poll = setInterval(function () { if (api()) { clearInterval(poll); try { api().on('ready', onReady); } catch (e) {} onReady(); } }, 500);
  setTimeout(function () { clearInterval(poll); }, 20000);

  function openChat() {
    if (!api()) return false;
    try { api().show(); api().open(); return true; } catch (e) { return false; }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-si-chat]');
    if (!a) return;
    if (openChat()) e.preventDefault();
  });

  // Floating "CHAT" button
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'si-chat-btn';
  btn.setAttribute('data-si-chat', '');
  btn.textContent = 'Chat';
  document.body.appendChild(btn);
  function vis() { btn.classList.toggle('is-visible', window.scrollY > 400); }
  window.addEventListener('scroll', vis, { passive: true });
  vis();

  // Footer: "Chat with us" after "Contact"; product page: a line under the benefits carousel.
  function links() {
    var c = document.querySelector('#footer a[href$="/pages/contact"], .si-footer a[href$="/pages/contact"]');
    if (c && !c.parentNode.parentNode.querySelector('[data-si-chat]')) {
      var li = c.closest('li');
      var a = document.createElement('a'); a.href = c.getAttribute('href'); a.setAttribute('data-si-chat', ''); a.className = c.className; a.textContent = 'Chat with us';
      if (li) { var nli = li.cloneNode(false); nli.appendChild(a); li.after(nli); } else c.after(a);
    }
    var slider = document.querySelector('.product-information section.slider-it');
    if (slider && !document.querySelector('.si-pdp-chat')) {
      var p = document.createElement('p'); p.className = 'si-pdp-chat';
      p.innerHTML = 'Questions? <a href="/pages/contact" data-si-chat>Chat with us</a>';
      slider.after(p);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', links); else links();
})();
